import React from "react";
import {
  IHighlightCommon,
  PopoverOptionComments,
} from "~/typings/annotate/annotation";
import { Trans } from "@lingui/react/macro";

export default function AnnotateComment({
  highlight,
  config,
  closePopover,
}: {
  config: PopoverOptionComments;
  highlight: IHighlightCommon;
  closePopover: () => void;
}) {
  const handleComment = () => {
    config.commentsClicked({
      ...highlight,
      canEdit: true,
      color: highlight.color,
    });

    closePopover();
  };

  return (
    <button
      onClick={handleComment}
      className="flex text-sm sm:text-base justify-center h-10 px-2 items-center sm:px-4 cursor-pointer space-x-1"
    >
      <Trans>Comment</Trans>
    </button>
  );
}
